export default "__VITE_ASSET__CA8tPdae__"